import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { dispatchCustomEvent, getColorTextLogo, toggleFullScreen } from "../../helpers/Utilities";
import Menu from "./Menu";
import Svg from "../Utilities/Svg";

/**
 * Header class
 * Renders the header of the site
 * Listens for the settings panel to be toggled and uses a state to determine if it is.
 */
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSettingsButton: props.location.pathname === "/",
      settingsPanelOpen: false,
      colorScheme: props.colorScheme,
      fullscreen: document.fullscreenElement !== null,
      layout: props.layout || "default",
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      // Route has changed!
      this.setState({ showSettingsButton: this.props.location.pathname === "/" });
    }
    if (prevProps.layout !== this.props.layout) {
      // Layout has changed!
      this.setState({ layout: this.props.layout });
    }
  }

  componentDidMount() {
    document.addEventListener("settingspanel-open", (newState) => {
      this.setState({ settingsPanelOpen: newState });
      this.handleSettingsPanelFocus(newState);
    });
  }

  componentWillUnmount() {
    document.removeEventListener("settingspanel-open", (newState) => {
      this.setState({ settingsPanelOpen: newState });
      this.handleSettingsPanelFocus(newState);
    });
  }

  handleSettingsPanelFocus = (event) => {
    setTimeout(() => {
      // menu has closed, set focus to the settings button
      if (event.detail === false) {
        const settingsBtn = document.getElementById("settingsBtn");
        if (settingsBtn) {
          settingsBtn.focus();
        }
      }
    }, 100);
  };

  handleFullScreen = () => {
    toggleFullScreen(!this.state.fullscreen);
    this.setState({ fullscreen: !this.state.fullscreen });
  };

  toggleSettingsPanel = () => {
    dispatchCustomEvent("togglesettingspanel", !this.state.settingsPanelOpen);
    this.setState({ settingsPanelOpen: !this.state.settingsPanelOpen });
  };

  toggleColorScheme = () => {
    dispatchCustomEvent("togglecolorscheme", this.state.colorScheme === "dark" ? "light" : "dark");
    this.setState({ colorScheme: this.state.colorScheme === "dark" ? "light" : "dark" });
  };

  render() {
    return (
      <header>
        <div className="row gutters-sm justify-spread no-wrap align-center">
          <div className="col no-shrink text-left">
            <NavLink to="/" className={({ isActive }) => (isActive && this.state.layout !== "easy-view" && this.state.layout !== "ninety-ball" ? "hide" : "show home-link")}>
              {getColorTextLogo()}
            </NavLink>
          </div>
          <div className="col shrink header-icon">
            <button aria-label={this.state.fullscreen === true ? "Exit full screen" : "Enter full screen"} className="icon-button" title="Toggle Full Screen" onClick={this.handleFullScreen}>
              <Svg icon="expand" />
            </button>
          </div>
          <div className="col shrink header-icon">
            <div className="translate-button primary-button icon-button">
              <Svg icon="location-dot" />
              <div id="google_translate_element" title="Translation"></div>
            </div>
          </div>
          <div className="col shrink header-icon">
            <button aria-label={`Toggle ${this.state.colorScheme === "dark" ? "light mode" : "dark mode"} Mode`} className="icon-button" title="Light/Dark Mode" onClick={this.toggleColorScheme}>
              <Svg icon={this.state.colorScheme === "dark" ? "moon" : "sun"} title={this.state.colorScheme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"} />
            </button>
          </div>
          <div className={this.state.showSettingsButton === true ? "col shrink header-icon" : "col hide"}>
            <button id="settingsBtn" aria-label="Settings" className="icon-button" title="Settings" onClick={this.toggleSettingsPanel}>
              <Svg icon="gears" title="Game Settings" />
            </button>
          </div>
          <div className="col shrink header-icon">
            <Menu />
          </div>
        </div>
      </header>
    );
  }
}

function HeaderWithLocation(props) {
  const location = useLocation();
  return <Header {...props} location={location} />;
}
export default HeaderWithLocation;
